module.exports = __webpack_public_path__ + "images/5-h5e8cf7f4d700dc0c56307b9881f48726.svg";